import {
  BookOpen,
  GraduationCap,
  Shield,
  User,
  UserCog,
  UserPlus,
  Users,
  type LucideIcon,
} from 'lucide-react';
import { ROLE_METADATA, UserRole } from '@/components/authnz/types/rbac';
import { cn } from '@/lib/utils';

const ROLE_ICON_BY_NAME: Record<string, LucideIcon> = {
  Shield,
  UserCog,
  User,
  BookOpen,
  GraduationCap,
  UserPlus,
  Users,
};

export function getRoleSwatchClass(role: UserRole): string {
  return ROLE_METADATA[role]?.swatchClass ?? 'bg-primary';
}

export function RoleSwatch({
  role,
  className,
}: {
  role: UserRole;
  className?: string;
}) {
  const metadata = ROLE_METADATA[role];
  const Icon = ROLE_ICON_BY_NAME[metadata?.icon ?? ''];
  const label = metadata?.displayName ?? role;

  return (
    <span className={cn('inline-flex items-center gap-1', className)} title={label}>
      <span
        data-testid="role-swatch"
        data-role={role}
        aria-hidden="true"
        className={cn('inline-block h-3 w-3 shrink-0 rounded-full', getRoleSwatchClass(role))}
      />
      {Icon ? (
        <Icon
          data-testid="role-symbol"
          data-role={role}
          aria-hidden="true"
          className={cn('h-3.5 w-3.5 shrink-0', metadata?.color ?? 'text-muted-foreground')}
        />
      ) : null}
    </span>
  );
}
